import { useState } from "react";
import WoSectionCard from "../common/WoSectionCard";
import TechNotes from "./TechNotes";

// Tech Notes section as an independent card matching the proposals/forms look.
function WoTechNotes({ woId, refreshToken }) {
  const [count, setCount] = useState(0);

  return (
    <WoSectionCard
      title="Tech Notes"
      count={count}
      toolTip="This is a place to make a quick note for users on both the Browser and Tech Apps. Viewable by all."
    >
      <TechNotes woId={woId} refreshToken={refreshToken} onCount={setCount} />
    </WoSectionCard>
  );
}

export default WoTechNotes;
